import type { MaterialOnTheFly } from '../../gql';

import { randFloat, randNumber, randUuid } from '@ngneat/falso';

import { mockComposition } from '../mockComposition';

import { mockMaterialSubcategory } from './mockMaterialSubcategory';
import { mockUnitOfMeasurement } from './mockUnitOfMeasurement';

const mockMaterialOnTheFly = (
    override?: Partial<MaterialOnTheFly>
): MaterialOnTheFly => ({
    materialOnTheFlyPublicId: randUuid(),
    materialSubcategory: mockMaterialSubcategory(),
    compositions: Array.from({ length: randNumber({ min: 1, max: 3 }) }, () =>
        mockComposition()
    ),
    weightValue: randFloat({ min: 0, max: 100, multipleOf: 0.01 }),
    weightUnit: mockUnitOfMeasurement({}, 'weight'),
    weightMeasure: mockUnitOfMeasurement({}, 'volume'),
    ...override,
    ['__typename']: 'MaterialOnTheFly',
});

export { mockMaterialOnTheFly };
